  <div class="card mt-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHome"></p-breadcrumb>
  </div>

  <div class="card mt-4">
    <div class="font-semibold text-xl mb-4"> Gestion des Destinataires</div>

    <div *ngIf="selectedDo" class="font-semibold text-xl mb-4">  DO Selectionné : {{ selectedDo.nom }}</div>


    <p-table [value]="doList"
             [paginator]="true"
             [rows]="10"
             [rowsPerPageOptions]="[5, 10, 20, 30, 40]"
             [loading]="isLoading"
             styleClass="p-datatable-gridlines"
             #dt>

      <ng-template pTemplate="header">
        <tr>
          <th >
            Code DO
            <input pInputText type="text" (input)="onCodeFilter($event)" placeholder="Filtrer code" />
          </th>
          <th >
            Nom DO
            <input pInputText type="text" (input)="onNomFilter($event)" placeholder="Filtrer nom" />
          </th>
          <th>Etat</th>
          <th>Action</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-doItem>
        <tr>
          <td>{{ doItem.code }}</td>
          <td>{{ doItem.nom }}</td>
          <td>
            <p-tag [value]="selectedDo?.nom === doItem.nom ? 'Selectionné' : 'Non selectionné'"
                   [severity]="selectedDo?.nom === doItem.nom ? 'success' : 'secondary'" />
          </td>
          <td>



         <p-button
            icon="pi pi-eye" class="mr-1" [rounded]="true" [outlined]="true"
            (onClick)="selectDo(doItem.nom)"
            pTooltip="Voir les destinataires">
          </p-button>



          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center">
            Aucun DO disponible
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="showRecipientsSection" class="card mt-4">
      <div *ngIf="selectedDo" class="font-semibold text-xl mb-4">
        Destinataires pour {{ selectedDo.nom }}
      <p-button icon="pi pi-times" label="Fermer" class="p-button-text"  (onClick)="closeRecipients()" /> </div>

    <div *ngIf="displayMode === 'simple'" class="p-3">
      <div class="grid">
        <div class="col-12 md:col-6">
          <p-card header="Destinataires Principaux (To)">
            <div *ngIf="recipients.to.length; else noTo">
              <div *ngFor="let email of recipients.to" class="mb-2">
                {{ email }}
              </div>
            </div>
            <ng-template #noTo>
              <p>Aucun destinataire principal</p>
            </ng-template>
          </p-card>
        </div>

        <div class="col-12 md:col-6">
          <p-card header="Copies (CC)">
            <div *ngIf="recipients.cc.length; else noCc">
              <div *ngFor="let email of recipients.cc" class="mb-2">
                {{ email }}
              </div>
            </div>
            <ng-template #noCc>
              <p>Aucune copie</p>
            </ng-template>
          </p-card>
        </div>
      </div>

      <div class="text-right mt-3">
        <p-button label="Modifier les destinataires" styleClass="p-button-primary" (onClick)="openEditModal({})" />
      </div>
    </div>

    <div *ngIf="displayMode === 'table'" class="p-3">
      <p-table [value]="dataSource" [paginator]="true" [rows]="5" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columns">{{ col }}</th>
            <th>Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td>{{ rowData.type || rowData.filtre || '-' }}</td>
            <td>
              <div *ngFor="let email of rowData.to">{{ email }}</div>
              <div *ngIf="!rowData.to.length">-</div>
            </td>
            <td>
              <div *ngFor="let email of rowData.cc">{{ email }}</div>
              <div *ngIf="!rowData.cc.length">-</div>
            </td>
            <td>
              <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-text p-button-sm"
                        (onClick)="openEditModal({rowData: rowData})" pTooltip="Modifier" />
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="columns.length + 1" class="text-center">
              Aucune donnée disponible
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

<p-dialog header="Modifier les destinataires" [(visible)]="displayEditModal" [modal]="true" [style]="{width: '700px'}">
  <div class="grid">
    <div class="col-12">
      <div class="mb-3 p-3 border-round" style="background-color: #e9ecef; color: #495057;">
        <i class="pi pi-info-circle mr-2"></i>

        Vérifiez que les adresses e-mail sont correctement saisies et
        que leurs domaines sont valides afin de garantir la bonne réception
        des rapports par l’ensemble des destinataires concernés

      </div>

      <div class="flex align-items-center gap-2 mb-3">
        <input
          type="text"
          pInputText
          [(ngModel)]="editFormData.newEmail"
          placeholder="email@exemple.com"
          class="flex-1"
          [ngClass]="{'ng-invalid ng-dirty': emailError}"
        />
        <p-button icon="pi pi-plus" label="Ajouter" styleClass="p-button-primary" (onClick)="addEmail()" />
      </div>


      <small *ngIf="emailError" class="p-error block mb-3">
        <i class="pi pi-exclamation-triangle mr-1"></i>
        Veuillez saisir une adresse email valide
      </small>
    </div>

    <div class="col-12 md:col-6">
      <p-card header="Destinataires Principaux (To)">
        <div *ngIf="editFormData.to.length === 0" class="p-error mb-2">
          <i class="pi pi-exclamation-triangle mr-1"></i>
          Au moins un destinataire principal est requis
        </div>

        <div *ngFor="let email of editFormData.to" class="flex align-items-center gap-2 mb-2">
          <span class="flex-1">{{ email }}</span>
          <p-button icon="pi pi-times" styleClass="p-button-danger p-button-sm"
                    (onClick)="removeEmail(email, 'to')" pTooltip="Supprimer" />
          <p-button icon="pi pi-arrow-right" styleClass="p-button-secondary p-button-sm"
                    (onClick)="moveToCC(email)" pTooltip="Déplacer vers CC" />
        </div>
        <div *ngIf="!editFormData.to.length" class="text-center">
          Aucun destinataire principal
        </div>
      </p-card>
    </div>

    <div class="col-12 md:col-6">
      <p-card header="Copies (CC)">
        <div *ngFor="let email of editFormData.cc" class="flex align-items-center gap-2 mb-2">
          <span class="flex-1">{{ email }}</span>
          <p-button icon="pi pi-times" styleClass="p-button-danger p-button-sm"
                    (onClick)="removeEmail(email, 'cc')" pTooltip="Supprimer" />
          <p-button icon="pi pi-arrow-left" styleClass="p-button-secondary p-button-sm"
                    (onClick)="moveToTO(email)" pTooltip="Déplacer vers To" />
        </div>
        <div *ngIf="!editFormData.cc.length" class="text-center">
          Aucune copie
        </div>
      </p-card>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center">
      <span *ngIf="hasChanges()">Modifications non enregistrées</span>
      <div class="flex gap-2">
        <p-button label="Annuler" styleClass="p-button-text" (onClick)="displayEditModal = false" />
        <p-button
          label="Enregistrer"
          styleClass="p-button-primary"
          [disabled]="!hasChanges() || editFormData.to.length === 0 || emailError"
          (onClick)="saveChanges()"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>



  <p-toast />
  <p-confirmDialog />
